import { ChatRoomType } from '@dinosband/bv-main-schema/dist/types'
import { BvDataCenterContext, SubscriptionManager } from '../../'
import { ChatRoomAddedPayload, CHAT_ROOM_ADDED } from '../chat-room'
import { ChatRoomLastMessages_Module } from './last-messages-module'

const _DEBUG_LOG = process.env.NODE_ENV !== 'production'
                   && !!process.env.VUE_APP_MESSENGER_DEBUG_LOG
                   && false

export class ChatRoomLastMessages {

  context: BvDataCenterContext

  private modules: ChatRoomLastMessages_Module[] = []
  private subscriptions = new SubscriptionManager()
  private _lastUpdatedAt?: string

  constructor (context: BvDataCenterContext) {
    this.context = context
    this.initSubscribe()
  }

  async init () {
  }

  cleanup () {
    // this.subscriptions.cleanup()
    this.modules.forEach((i) => i.cleanup())
    this.modules = []
  }

  private _module = (chatRoomId: number) => this.modules.find((i) => i.chatRoomIds.includes(chatRoomId))

  lastMessage (chatRoomId: number) {
    return this._module(chatRoomId)?.lastMessage(chatRoomId)
  }

  lastValidMessage (chatRoomId: number) {
    return this._module(chatRoomId)?.lastValidMessage(chatRoomId)
  }

  lastUpdatedMessage (chatRoomId: number) {
    return this._module(chatRoomId)?.lastUpdatedMessage(chatRoomId)
  }

  async initChatRooms (chatRoomIds: number[], channelId?: number) {
    const chatRoomIds_ = chatRoomIds.filter((i) => !this._module(i))
    if (!chatRoomIds_.length) {
      return
    }
    const module = new ChatRoomLastMessages_Module(this.context, chatRoomIds_, channelId)
    await module.init()
    this.modules.push(module)
  }

  cleanupChannel (channelId: number) {
    const selecteds = this.modules.filter((i) => i.channelId === channelId)
    selecteds.forEach((i) => i.cleanup())
    this.modules = this.modules.filter((i) => i.channelId !== channelId)
  }

  private initSubscribe () {
    this.subscriptions.init(this.context.pubsub)
    this.subscriptions.subscribe(CHAT_ROOM_ADDED, (value) => this.onChatRoomAdded(value))
  }

  private async onChatRoomAdded (value: ChatRoomAddedPayload) {
    // only 1:1 and helpDesk chatRooms are added automatically
    if (value.channelId && ![ChatRoomType.HELPDESK, ChatRoomType.COMMENTS].includes(value.type)) {
      return
    }
    await this.initChatRooms(value.chatRooms.map((i) => i.id))
  }

  async updateLastMessages (scope: 'all' | 'channel-chat-rooms') {
    let targets = this.modules
    if (scope === 'channel-chat-rooms') {
      targets = this.modules.filter((i) => !!i.channelId)
    }
    const results = await Promise.all(targets.map((i) => i.updateLastMessages()))
    return results.flatMap((i) => i ?? [])
  }

  onReconnected () {
    this.modules.forEach((i) => i.onReconnected())
  }

}

